import { z } from 'zod';

export const campaignSchema = z.object({
  type: z.enum(['DASHBOARD', 'POPUP']),
  startDateTime: z.string().optional(),
  endDateTime: z.string().optional(),
  horizontalMedia: z.any().optional(),
  verticalMedia: z.any().optional(),
});

export type CampaignFormValues = z.infer<typeof campaignSchema>;
